module.exports = __webpack_public_path__ + "img/logo.c72b9385.png";